import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import { styled } from "@mui/material/styles";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { Button, Link } from "@mui/material";
import "../assets/css/feedback.css";
import close from "../assets/images/close.svg";
import Logo from "../assets/images/Logo2.png";
import { useStoreDollHouseMap } from "../store";
import { shallow } from "zustand/shallow";
import { event } from "jquery";
import { sendPostRequest } from "../util";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Popupinfo from "../components/Popupinfo";
import CircularProgress from "@mui/material/CircularProgress";

let isSubmitted = false;

function Feedback(props) {
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      userid: state.userid,
      feedbacktitle: state.feedbacktitle,
      feedbackVisibiity: state.feedbackVisibiity,
      updateFeedbackVisibility: state.updateFeedbackVisibility,
      updateFeedbackSbtStatus: state.updateFeedbackSbtStatus,
    }),
    shallow
  );

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [rating, setRating] = React.useState(0);
  const [reviewtext, setReviewText] = React.useState("");
  const [infovisible, setinfovisible] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [ratingerror, setratingError] = React.useState("");
  const [reviewtexterror, setreviewtextError] = React.useState("");
  const [isratingvalid, setisratingvalid] = React.useState(false);
  const [isreviewtextvalid, setisreviewtextvalid] = React.useState(false);
  const [isAlreayOpened, setFeedbackOpenedAlready] = React.useState(false);
  const [feedbackText_1, setfeedbackText_1] = React.useState("");
  const [feedbackText_2, setfeedbackText_2] = React.useState("");

  {
  }

  useEffect(() => {
    if (dollhouseStore.feedbacktitle) {
      let explded_text = dollhouseStore.feedbacktitle.split("<br/>");

      if (explded_text.length > 0) {
        setfeedbackText_1(explded_text[0]);
        setfeedbackText_2(explded_text[1]);
      }
    }
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const clearValidation = () => {
    if (isratingvalid) {
      setisratingvalid(false);
      setratingError("");
    }

    if (isreviewtextvalid) {
      setisreviewtextvalid(false);
      setreviewtextError("");
    }
  };

  // const feedbackOpen = (event) => {
  //   if (
  //     event.clientY <= 0 ||
  //     event.clientX <= 0 ||
  //     event.clientX >= window.innerWidth ||
  //     event.clientY >= window.innerHeight
  //   ) {
  //     if (isSubmitted) {
  //       return;
  //     }
  //     if (isAlreayOpened) {
  //       return;
  //     }
  //     setOpen(true);
  //     setFeedbackOpenedAlready(true);
  //     //  window.removeEventListener("mouseout", feedbackOpen);
  //   }
  // };

  useEffect(() => {
    //window.addEventListener("mouseout", feedbackOpen);

    // document.addEventListener("visibilitychange", function () {
    //   if (document.hidden) {
    //     console.log("Browser tab is hidden");
    //     if (isSubmitted) {
    //       return;
    //     }
    //     setOpen(true);
    //   } else {
    //     console.log("Browser tab is visible");
    //   }
    // });

    setTimeout(() => {
      if (isSubmitted) {
        return;
      } else {
        setOpen(true);
      }
    }, 3 * 60 * 1000);
  }, []);

  useEffect(() => {
    if (isSubmitted) {
      return;
    } else {
      if (dollhouseStore.feedbackVisibiity) {
        setOpen(dollhouseStore.feedbackVisibiity);
      }
    }
  }, [dollhouseStore.feedbackVisibiity]);

  const handleSubmit = () => {
    let requestData = {
      rating: rating,
      feed_back: reviewtext,
      user_id: dollhouseStore.userid,
    };

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    sendPostRequest(
      process.env.REACT_APP_FEEDBACK_API,
      requestData,
      (error, resp) => {
        setLoading(false);

        if (error) {
          console.error("Error:", error);
        } else {
          if (resp.response === "success") {
            setinfovisible(true);
            setOpen(false);
            isSubmitted = true;
            dollhouseStore.updateFeedbackSbtStatus(true);
            clearValidation();
            let cb = setTimeout(() => {
              setinfovisible(false);
              clearTimeout(cb);
            }, 4000);
          }
        }
      }
    );
  };

  const validateForm = () => {
    let valid = true;

    if (reviewtext === "") {
      setisreviewtextvalid(true);
      setreviewtextError("Please fill the field.");
      valid = false;
    }

    // if (rating === 0) {
    //   setisratingvalid(true);
    //   setratingError("Please select the rating.");
    //   valid = false;
    // }

    return valid;
  };

  const handleClose = () => {
    setOpen(false);
    dollhouseStore.updateFeedbackVisibility(false);
  };

  const MGMRating = styled(Rating)({
    "& .MuiRating-iconFilled": {
      color: "#000000",
    },
    "& .MuiRating-iconHover": {
      color: "#000000",
    },
  });

  return (
    <>
      {infovisible ? (
        <Popupinfo
          message="Your feedback was submitted successfully!"
          type="success"
        />
      ) : (
        <></>
      )}

      <Dialog
        PaperProps={{ sx: { borderRadius: "20px" } }}
        fullScreen={fullScreen}
        open={open}
        // onClose={handleClose}
        aria-labelledby="MGM rating popup"
      >
        <DialogContent className="ratingPopup">
          <img className="ratingPopupClose" onClick={handleClose} src={close} />
          <>
            <div className="loginLogo">
              <img src={Logo} />
            </div>
            <p className="feedbackText">{feedbackText_1}</p>
            <p className="feedbackText">{feedbackText_2}</p>
            <FormControl sx={{ mt: 2, mb: 3, width: "100%" }}>
              <MGMRating
                sx={{ mx: "auto" }}
                size="large"
                name="MGMRating"
                value={rating}
                onChange={(event, newValue) => {
                  setRating(newValue);
                }}
                error={isratingvalid}
                helperText={ratingerror}
              />
            </FormControl>
            <FormControl sx={{ mb: 2, width: "100%" }}>
              <TextField
                placeholder="Tell us more about it."
                multiline
                rows={2}
                maxRows={4}
                InputProps={{ style: { fontSize: 14, padding: 7 } }}
                onChange={(event) => {
                  setReviewText(event.target.value);
                }}
                error={isreviewtextvalid}
                helperText={reviewtexterror}
              />
            </FormControl>
            <FormControl sx={{ mb: 2, width: "100%" }}>
              <Button
                sx={{ flexGrow: 1 }}
                className="btn-black"
                type="submit"
                variant="contained"
                onClick={handleSubmit}
                disabled={loading}
              >
                Submit
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: "#bda770",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </FormControl>
            <p className="feedbackLater" onClick={handleClose}>
              Ask me later
            </p>
          </>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Feedback;
